// extracted by mini-css-extract-plugin
export var shake = "_b-0";